
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesQuotationItemsGrid extends Serenity.EntityGrid<SalesQuotationItemsRow, any> {
        protected getColumnsKey() { return 'Sales.QuotationItems'; }
        protected getDialogType() { return SalesQuotationItemsDialog; }
        protected getIdProperty() { return SalesQuotationItemsRow.idProperty; }
        protected getInsertPermission() { return SalesQuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesQuotationItemsRow.localTextPrefix; }
        protected getService() { return SalesQuotationItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });

        }

    }
}